'use client';

import Image from '@/components/Image';
import MagicJump from '@/components/MagicJump';
import { useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import { ProductData } from '../types';

interface TrendProductItemMobileProps {
  product: ProductData;
  isFirstItem?: boolean;
  description?: string;
  onClick?: () => void;
  onExposure?: () => void;
}

export default function TrendProductItemMobile({
  product,
  isFirstItem = false,
  description,
  onClick,
  onExposure,
}: TrendProductItemMobileProps) {
  // 曝光检测
  const { ref: expRef, inView } = useInView({
    threshold: 0.5,
    triggerOnce: true,
  });

  useEffect(() => {
    if (inView && onExposure) {
      onExposure();
    }
  }, [inView, onExposure]);

  // 获取模特图（material/celebrity）或商品图
  const materialImage = product.image?.celebrity?.[0] || product.image?.material?.[0];
  const productGrayImage = product.image?.product_gray?.[0] || product.image?.product?.[0];

  // 获取模特图或商品图
  const displayImage = materialImage || productGrayImage;

  return (
    <div ref={expRef}>
      <MagicJump
        prefetch
        item={{
          jump_type: 2,
          Jump_target: product.shop_sku,
          sku: { shop_sku: product.shop_sku },
        }}
        onBeforeJump={onClick}
        aria-label={product.short_name || product.name}
        className="block rounded-[8px] overflow-hidden"
      >
        {/* 商品图片 - 使用自然高度，由 Waterfall 组件处理布局 */}
        <Image
          src={displayImage}
          alt={((description || product.short_name || product.name) ?? '').slice(0, 70)}
          width={200}
          height={isFirstItem ? 234 : 175}
          loading="eager"
          className={`w-full ${materialImage ? 'object-cover' : 'object-contain mix-blend-multiply'}`}
          style={{
            height: isFirstItem ? 234 : 175,
          }}
        />

        {/* 商品信息 */}
        <div className="bg-white p-[8px]">
          <h3 className="text-[13px] leading-[16px] line-clamp-2 text-[#282828] font-bb">
            {product.name || product.short_name}
          </h3>
          {description && (
            <p className="text-[12px] text-gray-600 line-clamp-2 mt-[6px]">{description}</p>
          )}
        </div>
      </MagicJump>
    </div>
  );
}
